<template>
    <div :class="{'has-file': showRemovedBtn}" class="file-input">
        <label v-if="!options.viewMode" class="file-input-label" :for="id">
            <input :id="id" type="file" :accept="options.accept" @change="fileChangeHandler"
                   name="attachment" class="file-input-field">
            <span class="name"><span class="text">{{ theFileName }}</span>
                <icon-base width="20" height="20" viewBox="0 0 20 20" class="upload-icon" icon-name="Добавить"><icon-add/></icon-base>
            </span>
        </label>
        <div v-else>
            <a v-for="(file, index) in files" :key="index">{{file.name}}</a>
        </div>
        <span @click.stop="clearFileHandler" class="remove-file" title="Удалить">
            <icon-base width="20" height="20" viewBox="0 0 20 20" icon-name="Удалить"><icon-remove/></icon-base>
        </span>
    </div>
</template>

<script>
    import IconAdd from "../icons/IconAdd";
    import IconBase from "../IconBase";
    import IconRemove from "../icons/IconRemove";

    export default {
        name: 'file-field',
        components: {IconRemove, IconBase, IconAdd},
        props: {
            id: {
                type: String,
            },
            options: {
                type: Object,
            },
            placeholder: {
                type: String,
            },
            value: {
                type: [Array, String, File]
            }
        },
        data() {
            return {
                //value: '',
                files: [],
                showRemovedBtn: false,
            };
        },
        computed: {
            theFileName() {
                if ((this.files.length > 0) && 'name' in this.files[0]) {
                    return this.files[0].name;
                }
                return this.options.placeholder ? this.options.placeholder : 'Выберите файл' ;
            },
        },
        methods: {
            fileChangeHandler(e) {
                this.files = Array.from(e.target.files);
                this.showRemovedBtn = true;
                this.$emit('input', this.files)
            },
            clearFileHandler() {
                const el = this.$el.querySelector('.file-input-field');
                const wrapper = document.createElement('form');
                this.wrapInputAndReset(el, wrapper);
            },
            wrapInputAndReset(el, wrapper) {
                // wrap input with form tag
                el.parentNode.insertBefore(wrapper, el);
                wrapper.appendChild(el);

                // reset input with form.reset()
                wrapper.reset();

                // place childNodes in document fragment
                const docFrag = document.createDocumentFragment();
                while (wrapper.firstChild) {
                    const child = wrapper.removeChild(wrapper.firstChild);
                    docFrag.appendChild(child);
                }

                // replace wrapper with document fragment
                wrapper.parentNode.replaceChild(docFrag, wrapper);

                this.files = [];
                this.showRemovedBtn = false;
            },
        },
        created() {
            if (this.value) {
                this.files = this.value instanceof Array ? this.value : [this.value];
            }
        }
    }
</script>


<style scoped>

</style>
